const reducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET-PAGE-LAYOUT':
        {
            const { itemIds, data } = action.data;
            const prevState = state[itemIds] || {};

            return {
                ...state,
                [itemIds]: {
                    ...prevState,
                    isError: false,
                    isFetching: false,
                    data
                }
            };
        }

        case 'SET-PAGE-LAYOUT-IS-ERROR':
        {
            const { itemIds, status } = action.data;
            const prevState = state[itemIds] || {};

            return {
                ...state,
                [itemIds]: {
                    ...prevState,
                    isError: status,
                    isFetching: false,
                    data: state[itemIds]?.data || {}

                }
            };
        }

        case 'SET-PAGE-LAYOUT-IS-FETCHING':
        {
            const { itemIds, status } = action.data;
            const prevState = state[itemIds] || {};

            return {
                ...state,
                [itemIds]: {
                    ...prevState,
                    isError: false,
                    isFetching: status,
                    data: state[itemIds]?.data || {}

                }
            };
        }
        default:
            return state;
    }
};

export default reducer;
